import { SameValueAsKeys } from '../../../../../../../lib/typeUtils';

export const chartNamesArray = ['deviceUsage24Hours', 'dataUsage24Hours', 'deviceChargeLevel', 'deviceUsage30Days', 'dataUsage30Days', 'averageDischarge30Days'] as const;
export const networkChartNamesArray = ['deviceNetwork', 'deviceWifi'] as const;
// Anomaly examination page charts (see useAnomalyExaminationEventFilters) whose event filters are
// session-only and never persisted to user settings - unlike every name above, which round-trips
// through getFiltersState/saveEventFilters to the backend. Deliberately excluded from isChartName
// below so one of these can never be mistaken for a persisted ChartName/NetworkChartName and sent
// to setChartEventFilters.
export const anomalyChartNamesArray = ['deviceEventsTimeline'] as const;

export type ChartName = typeof chartNamesArray[number];
export type NetworkChartName = typeof networkChartNamesArray[number];
export type AnomalyChartName = typeof anomalyChartNamesArray[number];

export const isChartName = (name: string): name is ChartName | NetworkChartName => {
  return chartNamesArray.includes(name as any) || networkChartNamesArray.includes(name as any);
};

type ChartNames = SameValueAsKeys<typeof chartNamesArray>;
export const chartNames: ChartNames = chartNamesArray.reduce((acc, type) => ({ ...acc, [type]: type }), {} as ChartNames);

type NetworkChartNames = SameValueAsKeys<typeof networkChartNamesArray>;
export const networkChartName: NetworkChartNames = { deviceNetwork: 'deviceNetwork', deviceWifi: 'deviceWifi' } as const;

type AnomalyChartNames = SameValueAsKeys<typeof anomalyChartNamesArray>;
export const anomalyChartNames: AnomalyChartNames = anomalyChartNamesArray.reduce((acc, type) => ({ ...acc, [type]: type }), {} as AnomalyChartNames);
